package com.nonopn.skydome.common.app.pages.main.model

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.unit.dp
import com.nonopn.icons.Pin
import com.nonopn.skydome.common.app.pages.estimate.EstimateScreenModelState
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.maps.XY
import ovh.plrapps.mapcompose.ui.state.MapState

class ComposeSimpleProjectHolder(
    mapState: MapState,
    flushCallouts: () -> Unit
) : Composer<Project, EstimateScreenModelState>(
    mapState,
    AppColor.BackgroundDarkBlueSemiTransparent,
    flushCallouts
) {
    override fun compose(
        states: EstimateScreenModelState,
        model: Project,
        xy: XY,
        onSelected: (Project) -> Unit
    ): @Composable (() -> Unit) = {
        Column(
            // normally 22 x 30
            Modifier.width(14.dp).height(20.dp)
        ) {
            Icon(
                painter = rememberVectorPainter(Icons.Rounded.Pin),
                contentDescription = "Project",
                tint = AppColor.White,
            )
        }
    }
}
